<script setup lang="ts">
import AssetImage from './AssetImage.vue'
defineProps<{
  eyebrow?: string
  title: string
  subtitle?: string
  assetKey?: string
}>()
</script>
<template>
  <header class="page-hero">
    <div v-if="assetKey" class="page-hero-art">
      <AssetImage
        :asset-key="assetKey"
        :alt="title"
        loading="eager"
        fetch-priority="high"
      />
    </div>
    <div class="page-hero-copy">
      <p v-if="eyebrow" class="eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <p v-if="subtitle" class="lead">{{ subtitle }}</p>
      <div v-if="$slots.meta" class="hero-meta"><slot name="meta" /></div>
    </div>
    <div v-if="$slots.actions" class="hero-actions">
      <slot name="actions" />
    </div>
  </header>
</template>
